import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-fcsc-experttool',
  templateUrl: './fcsc-experttool.component.html',
  styleUrls: ['./fcsc-experttool.component.scss'],
})
export class FcscExperttoolComponent {
  constructor() {}
}
